// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActionLoadingController from "./action_loading_controller"
application.register("action-loading", ActionLoadingController)

import TourGuideController from "./tour_guide_controller"
application.register("tour-guide", TourGuideController)

import ImageGalleryController from "./image_gallery_controller"
application.register("image-gallery", ImageGalleryController)

import Pages__AccountPanelController from "./pages/account_panel_controller"
application.register("pages--account-panel", Pages__AccountPanelController)

import Pages__MappingFormController from "./pages/mapping_form_controller"
application.register("pages--mapping-form", Pages__MappingFormController)

import Pages__OrdersRealtimeController from "./pages/orders_realtime_controller"
application.register("pages--orders-realtime", Pages__OrdersRealtimeController)

import Pages__StoreConnectController from "./pages/store_connect_controller"
application.register("pages--store-connect", Pages__StoreConnectController)

import RubyUi__AlertDialogController from "./ruby_ui/alert_dialog_controller"
application.register("ruby-ui--alert-dialog", RubyUi__AlertDialogController)

import RubyUi__AvatarController from "./ruby_ui/avatar_controller"
application.register("ruby-ui--avatar", RubyUi__AvatarController)

import RubyUi__CheckboxGroupController from "./ruby_ui/checkbox_group_controller"
application.register("ruby-ui--checkbox-group", RubyUi__CheckboxGroupController)

import RubyUi__DataTableColumnVisibilityController from "./ruby_ui/data_table_column_visibility_controller"
application.register("ruby-ui--data-table-column-visibility", RubyUi__DataTableColumnVisibilityController)

import RubyUi__DataTableController from "./ruby_ui/data_table_controller"
application.register("ruby-ui--data-table", RubyUi__DataTableController)

import RubyUi__DataTableSearchController from "./ruby_ui/data_table_search_controller"
application.register("ruby-ui--data-table-search", RubyUi__DataTableSearchController)

import RubyUi__DialogController from "./ruby_ui/dialog_controller"
application.register("ruby-ui--dialog", RubyUi__DialogController)

import RubyUi__DropdownMenuController from "./ruby_ui/dropdown_menu_controller"
application.register("ruby-ui--dropdown-menu", RubyUi__DropdownMenuController)

import RubyUi__FormFieldController from "./ruby_ui/form_field_controller"
application.register("ruby-ui--form-field", RubyUi__FormFieldController)

import RubyUi__PopoverController from "./ruby_ui/popover_controller"
application.register("ruby-ui--popover", RubyUi__PopoverController)

import RubyUi__SelectController from "./ruby_ui/select_controller"
application.register("ruby-ui--select", RubyUi__SelectController)

import RubyUi__SelectItemController from "./ruby_ui/select_item_controller"
application.register("ruby-ui--select-item", RubyUi__SelectItemController)

import RubyUi__SheetContentController from "./ruby_ui/sheet_content_controller"
application.register("ruby-ui--sheet-content", RubyUi__SheetContentController)

import RubyUi__SheetController from "./ruby_ui/sheet_controller"
application.register("ruby-ui--sheet", RubyUi__SheetController)

import RubyUi__SidebarController from "./ruby_ui/sidebar_controller"
application.register("ruby-ui--sidebar", RubyUi__SidebarController)

import RubyUi__TabsController from "./ruby_ui/tabs_controller"
application.register("ruby-ui--tabs", RubyUi__TabsController)

import RubyUi__ToastController from "./ruby_ui/toast_controller"
application.register("ruby-ui--toast", RubyUi__ToastController)

import RubyUi__ToasterController from "./ruby_ui/toaster_controller"
application.register("ruby-ui--toaster", RubyUi__ToasterController)
